import { render, staticRenderFns } from "./ChangePic.vue?vue&type=template&id=551d8970"
import script from "./ChangePic.vue?vue&type=script&lang=js"
export * from "./ChangePic.vue?vue&type=script&lang=js"
import style0 from "./ChangePic.vue?vue&type=style&index=0&id=551d8970&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports